/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import {
	createRouterSelector,
	useRouter,
	type Route,
	type JiraSpaRoute,
} from '@atlassian/react-resource-router';
import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types.tsx';
import type { RouteName } from '@jira/platform__routing-route-name-types/src/RouteName.tsx';
import { getPreviousRouterState, type RouterState } from './common/utils/index.tsx';

/**
 * @deprecated Selecting the entire route state will lead to excessive re-renders.
 * Instead, select specific parts of the route state that are needed using useIsActiveRoute
 * or addRouteListener @atlassian/react-resource-router
 */
// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
export const useCurrentRoute: (args_0: void) => JiraSpaRoute = createRouterSelector<JiraSpaRoute>(
	(state) => state.route,
);

// Use this only in situations where directly importing the route would cause a circular dependency
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const useRouteByName: (...args: any) => JiraSpaRoute | null = createRouterSelector<
	JiraSpaRoute | null,
	RouteName
>(
	(state, routeName) =>
		// oxlint-disable-next-line typescript/consistent-type-assertions
		(state.routes.find(({ name }) => name === routeName) as JiraSpaRoute | undefined) ?? null,
);

export const toInvariantRoute = ({
	name,
	path,
	query = undefined,
	exact = undefined,
}: Route): InvariantRoute => ({ name, path, query, exact });

export const usePreviousRouterState = (): RouterState | null => {
	// Force updates whenever the current route changes
	useRouter();

	return getPreviousRouterState();
};
